import ROUTE from '@app/navigationApp/routes';
import { trackEvent } from '@app/utils/amplitude';

export const REJECTION_ERROR_CODES = {
    CLIENT_DEDUPE_FAILED: 'CLIENT_DEDUPE_FAILED',
    MNRL_REJECTION: 'MNRL_REJECTION',
    AML_PEP_CHECK_FAILED: 'AML_PEP_CHECK_FAILED',
    NSDL_PAN_VERIFICATION_FAILED: 'NSDL_PAN_VERIFICATION_FAILED',
} as const;

export const REJECTION_HEADING = 'Unable to process your application';

export const ACTIVE_LOAN_MESSAGE =
    'You currently have an active loan with the lender. You can apply again after it is closed.';

export const ELIGIBILITY_MESSAGE =
    'Sorry, your application currently doesn’t meet lenders eligibility criteria. You can always try again later.';

export const REJECTION_MESSAGE_MAP: Record<string, string> = {
    [REJECTION_ERROR_CODES.CLIENT_DEDUPE_FAILED]: ACTIVE_LOAN_MESSAGE,
    [REJECTION_ERROR_CODES.MNRL_REJECTION]: ELIGIBILITY_MESSAGE,
    [REJECTION_ERROR_CODES.AML_PEP_CHECK_FAILED]: ELIGIBILITY_MESSAGE,
    [REJECTION_ERROR_CODES.NSDL_PAN_VERIFICATION_FAILED]: ELIGIBILITY_MESSAGE,
};

export const handleApplicationRejection = (error: any, navigation: any, sourcePage?: string): boolean => {
    const errorCode = typeof error === 'string' ? error : error?.data?.voltErrorCode;
    const message = errorCode ? REJECTION_MESSAGE_MAP[errorCode] : undefined;

    if (!message) {
        return false;
    }

    trackEvent('LOANREJECTED_PAGEVIEW', {
        source_page: sourcePage,
        be_error_code: errorCode,
    });

    navigation.navigate(ROUTE.APPLICATION_REJECTION, {
        message,
        heading: REJECTION_HEADING,
        rejectionCode: errorCode,
        sourcePage,
    });

    return true;
};
